// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cityId: __t.u64().primaryKey().name("city_id"),
  cityHallStructureId: __t.u64().name("city_hall_structure_id"),
  mayor: __t.identity(),
  name: __t.string(),
  centerX: __t.f32().name("center_x"),
  centerZ: __t.f32().name("center_z"),
  cityRank: __t.u8().name("city_rank"),
  radiusM: __t.u32().name("radius_m"),
  treasury: __t.i64(),
  incomeTax: __t.u16().name("income_tax"),
  propertyTax: __t.u16().name("property_tax"),
  salesTax: __t.u16().name("sales_tax"),
  specialization: __t.string(),
  status: __t.string(),
  foundedAt: __t.timestamp().name("founded_at"),
  nextUpdateAt: __t.timestamp().name("next_update_at"),
  lastElectionAt: __t.timestamp().name("last_election_at"),
  lastSpecChangeAt: __t.timestamp().name("last_spec_change_at"),
});
